// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".page_out[data-v-68c7b326]{width:100%;text-align:right}.ppp[data-v-68c7b326]{margin-bottom:8px}", ""]);
// Exports
module.exports = exports;
